<script lang="ts" setup>
import { useCityStore } from '@/store/city/city'

const {
  cityInfo: { phone },
} = useCityStore()

const openChat = () => window.carrotquest?.open()
</script>

<template>
  <div class="support">
    <the-button icon="calling" variant="tertiary" :href="`tel:${phone}`">
      Позвонить
    </the-button>

    <the-button icon="bubble-chat" variant="tertiary" @click="openChat">
      Написать в чат
    </the-button>
  </div>
</template>

<style lang="scss" scoped>
.support {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px 0;
  width: 100%;

  @include media('>=tablet', '<=desktop-mini') {
    grid-template-columns: 1fr 1fr;
    gap: 0 40px;
  }
}
</style>
